module.exports = __webpack_public_path__ + "img/media_6.4c77b7b8.png";